<script>
    import Axios from 'axios'
    import config from '../../libs/config.js';
    import api from '../../api'
    import { mapGetters, mapActions } from 'vuex'
    import _ from 'lodash'
    import _system from '../../libs/system'	

    import AOS from 'aos'
    import 'aos/dist/aos.css'

    import iziToast from 'izitoast'
    import 'izitoast/dist/css/iziToast.min.css';

export default {
  name: "Widget",
  data() {
    return {
      config,
      text: '',
      selectedTheme: '',
      welcomeMessages: [],
      currentPage : {},
      messages: [],
      website: {},
      setupWidgetUrl: '',
      threadId: '',
      latestRunId:'',
      latestMessageId: '',
      latestMessageObject: 0,
      keepingAsking: false,
      onTheLine:[],
      activethreadId: null,
      dev: false,
      botConfig: {
        name: 'AI Shopping Assistant',
        welcome: 'Hello 👋, How can I help you today?',
        position: 'right',
        scannedAt: '',
        additionalInstruction: '',
        style: {
          name: "Juphy's Light",
          header: {
            backgroundColor: '#f6f6f6',
            name: {
              textColor: '#202325'
            },
            status: {
              textColor: '#72777A'
            }
          },
          middle:{
            backgroundColor: '#ffffff',
            bot:{
              backgroundColor: '#f2f4f5',
              textColor: '#303437'
            },            
            agent:{
              backgroundColor: '#0070f0',
              textColor: '#ffffff'
            }
          },
          footer:{
            backgroundColor: '#f6f6f6',
            input:{
              backgroundColor: '#ffffff',
              borderColor: '#DDDDDD',
              textColor: '#222222'
            },            
            button:{
              backgroundColor: '#444444',
              textColor: '#ffffff'
            }
          }
        }
      },
      loading: {
        typing: false,
        guide: false,
        config: false,
        ai: false
      }
    };
  },
  computed: 
	    {
	        ...mapGetters('session', ['isLoggedIn','getUser', 'getRole', 'getJwt']),
          ...mapGetters('accounts', ['accounts']),
          ...mapGetters('networks', ['networks','networksByName']),
          ...mapGetters('tags', ['tagsByName']),          
          ...mapGetters('workspaceusers', ['workspaceusers']),  
          ...mapGetters('workspaces', ['currentWorkspace']),
          isAccountsPlatformShopifExists() {
      return _.find(this.accounts, (account) => {
        return account.platform == this.networksByName["Shopify"]._id;
      });
    }
        },
  methods: {
    keepAsking(){

      this.loading.typing = true;

      let payload = {
        query: _.first(this.onTheLine)
      }

      Axios.get(this.config.url +'/chatbot/threads/' + payload.query.message.thread_id + '/runs/'+ payload.query.run.id +'?pageId=' + this.currentPage._id)
        .then(response => {

          //{run, messages}

          if(response.data.run.status === 'completed'){
            this.loading.typing = false;
            this.messages.push({
              text: _.last(_.get(response.data, 'messages')).text,
              type: 'bot'
            });


            console.log('before removed: ', this.onTheLine)
            this.onTheLine = _.tail(this.onTheLine)
            console.log('removed: ', this.onTheLine)

            if(this.onTheLine.length){
              this.keepAsking();
              console.log('keeping aking bcz array has value: ')
            }else{
              this.keepingAsking = false;
            }

            setTimeout(() => {
              document.getElementById("wcw_messages_container").scrollTo(0, document.getElementById("wcw_messages_container").scrollHeight);
            },200)

            }

          //this.loading.typing = false;
          
          setTimeout(() => {
            if(response.data.run.status !== 'completed'){
              this.keepAsking();
            }
          },350)

        })
        .catch(error => {
          // Handle any errors here
          console.error('Error:', error);
        });
    },
    pushIntoLine(){

      window.analytics.track("Chatbot: Send Button Clicked");

      //Instant Render User Message
      this.messages.push({
        text: this.text,
        type: 'agent',
        object: {}
      });

      //Scroll Down after Render
      setTimeout(() => { document.getElementById("wcw_messages_container").scrollTo(0, document.getElementById("wcw_messages_container").scrollHeight); },200)

      //Add into line.
      this.onTheLine.push({
        text: this.text,
        type: 'agent',
        object: {}
      });

      //Only runs if there is not active run operation.
      if(!this.keepingAsking){
          this.keepingAsking = true;
          this.startRun(this.activethreadId);
        }
      
      this.text = '';
    },
    startRun(threadId){

      this.loading.typing = true;

      var urlRun = this.config.url + '/chatbot/messages?pageId=' + this.currentPage._id + '&isRun=true'
      var urlThread = this.config.url + '/chatbot/messages?pageId=' + this.currentPage._id + '&isRun=true&threadId=' + threadId

      var url = (threadId) ? urlThread : urlRun;

      let askPayload = { 
        content: _.first(this.onTheLine).text,
      }

      Axios.post(url, askPayload)
        .then(response => {
          
          this.activethreadId = response.data.message.thread_id
          this.checkRun(response.data);

        })
        .catch(error => {
          // Handle any errors here
          this.loading.typing = false;
          this.messages.push({
            text: "Would you mind repeating that for me, please? I want to make sure I've understood you correctly.",
            type: 'bot'
          });
          console.error('Error:', error);
        });

    },
    checkRun(threadAndRunObject){

      Axios.get(this.config.url + '/chatbot/threads/' + threadAndRunObject.message.thread_id + '/runs/'+ threadAndRunObject.run.id +'?pageId=' + this.currentPage._id, {
        timeout: 5000
      })
        .then(response => {

          //{run, messages}

          //response.data.run.status = 'completed'

          //Check if completed or not
          if(response.data.run.status === 'completed'){

            let linkPreview = '';

            //Regenerate reply for the URLs
            let regex_pattern = /\[(!?\[.*?\]\(.*?\)|.*?)\]\((https?:\/\/.*?)\)/gi
            let answerString = _.last(_.get(response.data, 'messages')).text;
            //let exampleString = "Moreover, it's a one-size-fits-most product with an adjustable drawstring to ensure a snug fit. To purchase our Balaclava, you can visit this link: [Balaclava Link](https://evergreenoutdoor.store/products/balaclava). We have 7 left in our inventory and [kalaclava Link](https://evergreenoutdoor.store/products/gravity) it is priced at $22.50. Please let me know if you need more information."

            const link_matches = answerString.match(regex_pattern);

            if(link_matches && link_matches.length){
              for (const markdown_link of link_matches) {
                regex_pattern.lastIndex = 0;
                let execResult = regex_pattern.exec(markdown_link)
                let text = execResult[1];
                let url =  execResult[2];
                let aHref = '<a target="_blank" href="' + url + '">' + text + '</a>'

                //Assign the first link found for the preview only once
                if(!linkPreview.length){
                  linkPreview = url;
                }

                answerString = answerString.replace(markdown_link, aHref);
              }
            }
            
            //render reply
            this.messages.push({
              text: answerString,
              type: 'bot'
            });

            //Scroll Down after Render
            setTimeout(() => { document.getElementById("wcw_messages_container").scrollTo(0, document.getElementById("wcw_messages_container").scrollHeight); },200)

            this.loading.typing = false;

            if(linkPreview.length && linkPreview.includes('products')){
              //trigger preview here
              //this.linkPreviewGenerator(linkPreview)
              this.linkPreviewGeneratorJson(linkPreview)
            }

            //Remove the processed message from queue
            this.onTheLine = _.tail(this.onTheLine)
      
            //Check if there are more messages in queue
            if(this.onTheLine.length){
              this.startRun(threadAndRunObject.message.thread_id);
            }else{
            //No message
              this.keepingAsking = false;
            }


            }else{
              //Not completed 
              setTimeout(() => {
                this.checkRun(threadAndRunObject);
              }, 1200)
            }
          

        })
        .catch(error => {
          // Handle any errors here
          this.loading.typing = false;
          this.messages.push({
            text: "I hope it's not too much trouble, but I'd love if you could say that one more time for clarity.",
            type: 'bot'
          });
          console.error('Error:', error);
        });
    },
    linkPreviewGenerator(url){
      this.loading.typing = true;
            var metaUrl = 'https://widget.juphy.com/metadata'
            //var metaUrl = 'http://localhost:5555/metadata'

              Axios.post(metaUrl, { url })
              .then(metaData => {

                setTimeout(() => {

                  this.messages.push({
                    title: (metaData.data.title && metaData.data.title.length) ?metaData.data.title : '',
                    desc: (metaData.data.description && metaData.data.description.length) ? metaData.data.description.slice(0,100) + '...' : '',
                    image: (metaData.data.image && metaData.data.image.length) ? metaData.data.image : '',
                    url: url,
                    rich: true,
                    type: 'bot'
                  });

                this.loading.typing = false;

                  setTimeout(() => {
                    document.getElementById("wcw_messages_container").scrollTo(0, document.getElementById("wcw_messages_container").scrollHeight);
                  },200)

                },500)

            }).catch(error => { 
              console.error('Error:', error); 
              this.loading.typing = false;
            });
    },
    linkPreviewGeneratorJson(url){
      this.loading.typing = true;
            var metaUrl = 'https://widget.juphy.com/metadata'
            //var metaUrl = 'http://localhost:5555/metadata'

              Axios.get(url + '.json')
              .then(metaData => {

                //console.log(metaData);
                //return metaData
                setTimeout(() => {
                  this.messages.push({
                    title:  _.get(metaData, 'data.product.title', ''),
                    desc:  new DOMParser().parseFromString(_.get(metaData, 'data.product.body_html', '').slice(0,100) + '...', "text/html").body.textContent || "",
                    image: _.get(metaData, 'data.product.image.src', ''),
                    url: url,
                    rich: true,
                    type: 'bot'
                  });

                this.loading.typing = false;

                  setTimeout(() => {
                    document.getElementById("wcw_messages_container").scrollTo(0, document.getElementById("wcw_messages_container").scrollHeight);
                  },200)

                },500)

            }).catch(error => { 
              console.error('Error:', error); 
              this.loading.typing = false;
            });
    },
    publishClicked(){
      window.analytics.track("Chatbot: Publish Button Clicked");
    },
    welcoming(){
      const JuphyWelcomeMessages = [
    { "delay": 1000, "text": "I'm your new AI Shopping Assistant!" },
    { "delay": 4000, "text": "Give me a moment to check out your Shopify store... 🔍" },
    { "delay": 6000, "text": "I'm getting to know your products and policies right now. 📚" },
    { "delay": 10000, "text": "This might take a little while, up to 30 seconds. ⏳" },
    { "delay": 30000, "text": "Almost done setting up for testing... 🛠️" },
    { "delay": 40000, "text": "You have some fantastic products! I'm excited to learn all the details. 🌟" },
    { "delay": 50000, "text": "Just a bit longer, please hang tight! 🙏" }
]


      // Group messages by their delay
      const groupedMessages = _.groupBy(JuphyWelcomeMessages, 'delay');

      // Function to display messages with their corresponding delays
        for (const delay in groupedMessages) {
          const messages = groupedMessages[delay];
          messages.forEach(message => {
            setTimeout(() => {
              this.welcomeMessages.push(message.text);
            }, message.delay);
          });
        }
    },
    updateAi(){

      this.loading.ai = true;

      this.welcoming();

      const payload = {
        body: {
          shop: this.currentPage
        }
      }

      _system.services.chatbot.generateAi(payload, (err, data) => {
        if(err)  {
          iziToast.success({ position: 'bottomLeft', title: 'AI Assistant is ready to test!', });
          this.loading.ai = false;
          return;
        } 

        this.loading.ai = false;

        this.saveConfig(null, Date.now().toString());

        iziToast.success({ position: 'bottomLeft', title: 'AI Assistant is ready to test 🚀', });

      });
    },


    updateAiByPublic(){
      this.loading.ai = true;

      this.welcoming();

      const payload = {
        body: {
          shop: this.currentPage
        }
      }
      _system.services.chatbot.generateAiByPublic(payload, (err, data) => {
        if(err)  {
          iziToast.success({ position: 'bottomLeft', title: 'AI Assistant is ready to test!!', });
          this.loading.ai = false;
          return;
        } 

        this.loading.ai = false;

        this.saveConfig(null, Date.now().toString());

        iziToast.success({ position: 'bottomLeft', title: 'AI Assistant is ready to test 🚀🚀', });

      });
    },


    setTheme(){
      window.analytics.track("Chatbot: Theme Selection Clicked");
      this.botConfig.style = _.find(this.themes, { name: this.selectedTheme })

    },
    setWelcomeMessage(){
      console.log('typed')
    },
    saveConfig(defaultConfig, scannedAt){

    if(scannedAt){
      this.botConfig.scannedAt = scannedAt;
    }

    let payload = {
      query: {
        pageId: this.currentPage._id
      },
      body: this.botConfig
    }

    if(defaultConfig){
      payload.body = defaultConfig;
    }

    _system.services.accounts.updateConfig(payload, (err, updatedPage) => {
        if(err) return iziToast.error({ position: 'bottomLeft', title: `${err.data.message}`, });

        iziToast.success({ position: 'bottomLeft', title: 'Changes Saved', });

    });               

    }
  },
  mounted() {

    this.dev = this.$route.query.dev;

    window.hljs.initHighlightingOnLoad();
  
     new window.Picker({
        parent: document.querySelector('#header'),
        color: this.botConfig.style.header.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.header.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#header_name'),
        color: this.botConfig.style.header.name.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.header.name.textColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#header_status'),
        color: this.botConfig.style.header.status.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.header.status.textColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#middle'),
        color: this.botConfig.style.middle.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.middle.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#middle_bot_background'),
        color: this.botConfig.style.middle.bot.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.middle.bot.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#middle_bot_text'),
        color: this.botConfig.style.middle.bot.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.middle.bot.textColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#middle_agent_background'),
        color: this.botConfig.style.middle.agent.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.middle.agent.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#middle_agent_text'),
        color: this.botConfig.style.middle.agent.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.middle.agent.textColor = color.rgbString
       };


       new window.Picker({
        parent: document.querySelector('#footer'),
        color: this.botConfig.style.footer.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#footer_input_background'),
        color: this.botConfig.style.footer.input.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.input.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#footer_input_text'),
        color: this.botConfig.style.footer.input.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.input.textColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#footer_input_border'),
        color: this.botConfig.style.footer.input.borderColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.input.borderColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#footer_button_background'),
        color: this.botConfig.style.footer.button.backgroundColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.button.backgroundColor = color.rgbString
       };

       new window.Picker({
        parent: document.querySelector('#footer_button_text'),
        color: this.botConfig.style.footer.button.textColor,
        popup: 'bottom',
        editorFormat: 'hex'
      }).onChange = (color) => { 
        this.botConfig.style.footer.button.textColor = color.rgbString
       };

      $('.ui.accordion').accordion();


     
  },
  created() {
    let defaultWidgetConfig = {
        "name" : "AI Shopping Assistant",
        "welcome" : "Hello 👋, How can I help you today?",
        "position" : "right",
        "scannedAt": '',
        "style" : {
            "name" : "Juphy's Light",
            "header" : {
                "backgroundColor" : "#f6f6f6",
                "name" : {
                    "textColor" : "#202325"
                },
                "status" : {
                    "textColor" : "#72777A"
                }
            },
            "middle" : {
                "backgroundColor" : "#ffffff",
                "bot" : {
                    "backgroundColor" : "#f2f4f5",
                    "textColor" : "#303437"
                },
                "agent" : {
                    "backgroundColor" : "#0070f0",
                    "textColor" : "#ffffff"
                }
            },
            "footer" : {
                "backgroundColor" : "#f6f6f6",
                "input" : {
                    "backgroundColor" : "#ffffff",
                    "borderColor" : "#DDDDDD",
                    "textColor" : "#222222"
                },
                "button" : {
                    "backgroundColor" : "#444444",
                    "textColor" : "#ffffff"
                }
            }
        }
    }



    let getRandomPage = _.find(this.accounts, { platform: this.networksByName['Shopify']._id });

    this.currentPage = _.find(this.accounts, { _id: this.getUser.themeCurrentPageId });

    if(!this.currentPage) {
      this.currentPage = getRandomPage;
    }

    if(!this.currentPage) {
      return window.location.href = 'https://apps.shopify.com/juphy?show_store_picker=1'
    }

    this.loading.config = true;
    _system.services.accounts.getConfig({ pageId: this.currentPage._id} , (err, data) => {
        if(err) return console.log(err.data.message);
        
        if(data.widgetConf && data.widgetConf.name){
          this.botConfig = data.widgetConf
          if(!this.botConfig.scannedAt || (this.botConfig.scannedAt && this.botConfig.scannedAt.length == 0)){
            this.updateAi();
          }
          this.selectedTheme = data.widgetConf.style.name
          this.loading.config = false;
        }else{
          this.saveConfig(defaultWidgetConfig);
          this.updateAi();
          this.selectedTheme = defaultWidgetConfig.style.name
          this.loading.config = false;
        }
    });   

    this.themes = [{
          name: "Juphy's Light",
          header: {
            backgroundColor: '#f6f6f6',
            name: {
              textColor: '#202325'
            },
            status: {
              textColor: '#72777A'
            }
          },
          middle:{
            backgroundColor: '#ffffff',
            bot:{
              backgroundColor: '#f2f4f5',
              textColor: '#303437'
            },            
            agent:{
              backgroundColor: '#0070f0',
              textColor: '#ffffff'
            }
          },
          footer:{
            backgroundColor: '#f6f6f6',
            input:{
              backgroundColor: '#ffffff',
              borderColor: '#DDDDDD',
              textColor: '#222222'
            },            
            button:{
              backgroundColor: '#444444',
              textColor: '#ffffff'
            }
          }
        },{
  "name": "Fancy Dracula",
  "header": {
    "backgroundColor": "#282a36",
    "name": { "textColor": "#f8f8f2" },
    "status": { "textColor": "#6272a4" }
  },
  "middle": {
    "backgroundColor": "#1e1e1e",
    "bot": { 
      "backgroundColor": "#282a36", 
      "textColor": "#f1fa8c"
    },
    "agent": {
      "backgroundColor": "#50fa7b",
      "textColor": "#282a36"
    }
  },
  "footer": {
    "backgroundColor": "#282a36",
    "input": {
      "backgroundColor": "#44475a",
      "borderColor": "#6272a4",
      "textColor": "#f8f8f2"
    },
    "button": {
      "backgroundColor": "#ff79c6",
      "textColor": "#282a36"
    }
  }
}]






  }
};
</script>

<template>
<span>

  <div v-show="loading.ai" style="position: fixed; top: 0; bottom: 0; right: 0; left: 0; background-color: rgba(0, 0, 0, 0.85); z-index: 999999999; color: white; padding: 1rem;">
    <div class="ui basic huge segment" style=" margin: 0 auto; max-width: 400px; ">
    <p> <i class="spinner loading icon"></i> </p>
    <p>Welcome 👋,</p>
      <p data-aos="fade" v-for=" welcomeMessage in welcomeMessages" :key="welcomeMessage">
        {{ welcomeMessage }}
      </p>
  </div>
  </div>

  <!-- https://evergreenoutdoor.store/admin/themes/current/editor?appEmbed=f68438fc-3793-4355-a683-ded84ca39046/juphy-widget&context=apps&activateAppId=f68438fc-3793-4355-a683-ded84ca39046/juphy-widget -->

  <div v-if="isAccountsPlatformShopifExists" class="ui grid">
<iframe :src="$custom.config.iframe.url + '/login?token=' + getJwt + '&editorUrl='+ getUser.themeEditorUrl +'&redirect='" style="width: 100%; padding: 0; margin:0; height: 100vh; min-height: 100vh;" frameborder="0"></iframe>
</div>

<div v-if="this.dev" class="ui stackable grid">

<div v-if="loading.config" style="
top: 0; 
bottom: 0; 
left: 0; 
right: 0; 
position: absolute; 
background: rgba(255,255,255,0.95); 
z-index: 9999999999999; 
display: flex;   
align-items: center;
flex-direction: column;
gap: 1rem;">
<div style="margin-top: 15rem;">
  <img class="ui image centered" style="width: 55px;" src="/img/logo.png" alt="">
</div>
  <div>Widget Configurations Loading ...</div>
</div>

<div style="background: #f2f2f2" class="row">
  <div style="background: #f2f2f2" class="sixteen wide column">
    <div class="ui grid">
      <div class="ten wide column">
        <div class="ui compact menu">
        <div class="ui simple dropdown item">
          {{currentPage.name}}
          <i class="dropdown icon"></i>
          <div class="menu">
              <a class="item" target="_blank" href="https://apps.shopify.com/juphy?show_store_picker=1">
                Add New Store
              </a>
          </div>
        </div>
      </div>
      </div>
      <div class="six wide column right aligned">
        <a :href="'http://localhost:8080/v1/?juphy_widget_token='+ currentPage._id +'&brand_name='+ botConfig.name +'&config='+ encodeURIComponent(JSON.stringify(botConfig)) +'&local=true&testing=true'" class="ui right labeled icon large green button">
          <i class="right arrow icon"></i>
          Test
        </a>
        <a @click="publishClicked()" :href="getUser.themeEditorUrl" class="ui right labeled icon large green button">
          <i class="right arrow icon"></i>
          Publish Now
        </a>
      </div>
    </div>

  </div>
</div>

<!--   <div class="ui padded stackable grid">
  <div class="sixteen wide column left aligned">
    <div style="display: inline-block; margin:0;" class="ui basic segment">
      <label for="sizeSelect">Company Size</label>
             <select class="ui fluid dropdown" name="size" id="sizeSelect">
                <option v-for="(size, i) in companySize" :key="i" :value="size">
                   {{size}}
                </option>
             </select>
    </div>
    <div style="margin:0;" class="ui basic segment right floated">
      <div class="ui basic button">{{currentPage.name}}</div>
      <a href="/logout" class="ui button">Logout</a>
    </div>
</div>
</div> -->

<div style="padding-top: 1rem;" class="ui stackable grid">

<div class="six wide column">

  <div v-if="loading.ai" class="ui fluid icon large button">Preparing AI Assistant, just a moment... <i class="notched circle loading icon"></i> </div>
  <div v-if="loading.ai" class="ui divider"></div>

<div id="WebChatwidget" style="width: 100%; position: relative;" class="WebChatwidget">
<div v-if="loading.ai" style="z-index: 9999999; border-radius: 10px; position:absolute; top: 0; bottom: 0; left: 0; right:0; background: rgb(250, 250, 250, 0.9);">
  <img style="width: 250px; height: 250px; border-radius: 180px; margin-left: 18%; margin-top: 40%;" src="https://cdn.dribbble.com/users/457852/screenshots/8649464/artificial-intelligence-voice-assistant.gif" alt="">
  </div>
  <div class="wcw_wrapper">
    <div class="wcw_header">
      <div :style=" { background: botConfig.style.header.backgroundColor}" class="content">
<!--               <div class="agents">
          <img
            src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
            alt=""
          />
        </div> -->
        <div class="status">
          <div class="label" style="opacity: 0.9">
            <div :style="{ color: botConfig.style.header.name.textColor}" class="widgetName">{{botConfig.name}}</div>
          </div>
          <div class="label">
            <div><span class="indicator"></span></div>
            <div :style="{ color: botConfig.style.header.status.textColor}" class="widgetStatus" >Always active</div>
          </div>
        </div>
<!--               <div id="wcw_close" class="wcw_close" onclick="triggerWidget()">
          <svg
            class="svg"
            width="24px"
            height="24px"
            enablebackground="new 0 0 32 32"
            fill="#72777A"
            stroke="none"
            version="1.1"
            viewBox="-3.2 -3.2 32.4 38.4"
            xmlspace="preserve"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="m16 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
            ></path>
            <path
              d="m6 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
            ></path>
            <path
              d="m26 13c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
            ></path>
          </svg>
        </div> -->
      </div>
    </div>
    <div id="wcw_messages_container" :style="{ background: botConfig.style.middle.backgroundColor }" class="wcw_messages_container">
      <ul id="wcw_messages">

        <li 
        v-if="botConfig.welcome && botConfig.welcome.length"
        class="clearfix bot"
        >
          <div :style="{ background: botConfig.style.middle.bot.backgroundColor, color: botConfig.style.middle.bot.textColor }" class="content">
            {{botConfig.welcome}}
          </div>
        </li>

        <li v-for="message in messages" 
        :key="message.text" 
        :class="'clearfix ' + message.type" 
        >
<!--                 <img
            v-if=" message.type == 'bot'"
            class="msgIcon"
            src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
            alt=""
          /> -->
          <div :style="{ background: botConfig.style.middle[message.type].backgroundColor, color: botConfig.style.middle[message.type].textColor }" :class="'content ' + message.type">

            <span v-if="!message.rich" v-html="message.text"></span>

            <div v-if="message.rich" class="richMsg">
              <div class="richMsgContainer">
                <div :style="{ color: botConfig.style.middle['bot'].textColor }" class="richMsgTitle">{{message.title}}</div>
                <span :style="{ color: botConfig.style.middle['bot'].textColor }" class="richMsgDesc">{{message.desc}}</span>
                <div v-if="message.image.length" class="richMsgImg" :style="'background: url(' + message.image + '); height: 120px; width: 100%; background-size: contain; background-repeat: no-repeat; background-position: center; background-color: #fff; border-radius: 10px;'">
                </div>
                  <div class="richMsgButton">
                    <a :style="{ color: botConfig.style.middle['bot'].textColor }" target="_blank" :href="message.url" class="button2">View Details</a>
                  </div>
                </div>
              </div>

              <!-- <span v-if="message.type == 'bot' && !message.rich"> <div class="ui mini label">Retrain</div></span> -->

          </div>

          

        </li>

<!--               <li :class="'clearfix bot'" >
          <img
            class="msgIcon"
            src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
            alt=""
          />
          <div :class="'content bot'">
            <div class="richMsg">
              <div class="richMsgContainer">
                <div class="richMsgTitle">Here is the Puma sneakers 👟 </div>
                <span class="richMsgDesc">The perfect blend of style and comfort for your everyday adventures.</span>
                <div class="richMsgImg" style="
                background: url('https://gisou.com/cdn/shop/products/PDP_Gisou_Hair_Perfume_100ml-01-4x5_600x750_crop_center@2x.jpg?v=1645455449');
                height: 120px;
                width: 100%;
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                background-color: #fff;
                border-radius: 10px;
                ">
                </div>
                  <div class="richMsgButton">
                    <button class="button2">View Product Details</button>
                  </div>
                </div>
              </div>
          </div>
        </li> -->

        <li v-if="loading.typing"
        id="loading___" :class="'clearfix bot'" >
<!--                 <img
            class="msgIcon"
            src="https://www.svgrepo.com/show/382095/female-avatar-girl-face-woman-user-4.svg"
            alt=""
          /> -->
          <div :style="{ background: botConfig.style.middle['bot'].backgroundColor, color: botConfig.style.middle['bot'].textColor }" :class="'content bot'">    <div class="dots">
                <span>typing</span>
                <span class="dot">.</span>
                <span class="dot">.</span>
                <span class="dot">.</span> <!-- This dot will animate last -->
            </div>
            
          </div>
        </li>
<!--               <li class="clearfix">
          <div class="content button" style="background: transparent">
            <div
              class="button"
              onclick="buttonContent('Kargo durumunu nasil sorgularim?')"
              data-content="Kargo durumunu nasil sorgularim?"
            >
              Kargo Durumu
            </div>
            <div
              class="button"
              onclick="buttonContent('Urun iade kosullari nelerdir?')"
              data-content="Urun iade kosullari nelerdir?"
            >
              Urun Iade Kosullari
            </div>
          </div>
        </li> -->
<!--               <li
          id="typing"
          class="clearfix"
          style="display: none"
          data-aos="fade-right"
        >
          <div class="content">
            <img
              src="https://media.tenor.com/G1VOo6fVsn4AAAAC/keyboard-type.gif"
              alt=""
              style="
                width: 36px;
                height: 30px;
                border-radius: 22px;
                vertical-align: middle;
                padding-right: 6px;
              "
            /><span>typing...</span>
          </div>
        </li> -->
      </ul>
    </div>
    <form id="wcw_form" :style="{ background: botConfig.style.footer.backgroundColor }" @submit.prevent="pushIntoLine()">
      <input
        :style="{ background: botConfig.style.footer.input.backgroundColor, color: botConfig.style.footer.input.textColor, 'border-color': botConfig.style.footer.input.borderColor  }"
        id="wcw_input"
        v-model="text"
        placeholder="Type a message..."
        autocomplete="off"
      /><button id="wcw_form_button">
        <svg
          :fill="botConfig.style.footer.button.backgroundColor"
          version="1.1"
          id="ic_send"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 24.00 24.00"
          xml:space="preserve"
          width="44px" 
          height="44px"
          transform="matrix(1, 0, 0, 1, 0, 0)rotate(-45)"
          stroke="#FFFFFF"
          stroke-width="0.00024000000000000003"
        >
          <g
            id="SVGRepo_bgCarrier"
            stroke-width="0"
            transform="translate(0,0), scale(1)"
          >
            <rect
              x="0"
              y="0"
              width="24.00"
              height="24.00"
              rx="12"
              :fill="botConfig.style.footer.button.backgroundColor"
              strokewidth="0"
            ></rect>
          </g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke="#CCCCCC"
            stroke-width="0.288"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <g id="ic_send_icon">
              <path d="M2,3v7.8L18,12L2,13.2V21l20-9L2,3z"></path>
            </g>
            <rect class="st0" width="24" height="24"></rect>
          </g>
        </svg>
      </button>
    </form>
  </div>
</div>
<div :style="{margin: 0, 'text-align': botConfig.position }" class="ui basic segment">
<div id="widget-chat-button" :style="'position: relative; display: inline-block; width: 50px; height: 50px; border-radius: 50%; box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 8px 0px; cursor: pointer; z-index: 999999999; transition: all 0.2s ease-in-out 0s; transform: scale(1);background-color:' + this.botConfig.style.footer.button.backgroundColor + ';'"><div style="display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; z-index: 999999999;"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" class="w-6 h-6 text-white" width="24px" height="24px" style="width: 24px; height: 24px; fill: none; display: block;"><path stroke-linecap="round" stroke-linejoin="round" d="M12 20.25c4.97 0 9-3.694 9-8.25s-4.03-8.25-9-8.25S3 7.444 3 12c0 2.104.859 4.023 2.273 5.48.432.447.74 1.04.586 1.641a4.483 4.483 0 01-.923 1.785A5.969 5.969 0 006 21c1.282 0 2.47-.402 3.445-1.087.81.22 1.668.337 2.555.337"></path></svg><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#ffffff" class="w-6 h-6 text-white" width="24px" height="24px" style="width: 24px; height: 24px; fill: none; display: none;"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"></path></svg></div></div>
</div>

</div>
<div class="ten wide column">

<!-- <div class="ui padded segment">
<div class="ui top attached large label">Step 1 - Test 🚀</div>
<p>Hello there!</p>
<p>Ready to explore? Your Sales Assistant awaits. Jump in and start testing - it's easy and fun! 👉</p>
</div> -->

<div class="ui padded segment">
<div class="ui top attached large label"> <i class="paint brush icon"></i> Customize</div>

<div class="ui equal width form">
<div class="field">
<label>Name</label>
<input placeholder="Alya" v-model="botConfig.name" type="text">
</div>
<div class="field">
<label>Welcome message</label>
<input placeholder="How can I help you today?" v-model="botConfig.welcome" type="text">
</div>
<div class="field">
<label>Themes</label>
<select class="ui dropdown" @change="setTheme()" v-model="selectedTheme" >
<option v-for="theme in themes" :key="theme.name" :value="theme.name">{{ theme.name }}</option>
</select>
</div>

<div class="field">
<div class="ui fluid accordion styled">
<div class="title">
<i class="dropdown icon"></i>
Advanced customization
</div>
<div class="content">

<div class="field">
<div class="fields">
<div class="field">
<label>Header</label>
<div id="header" class="colorPicker">
  <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.header.backgroundColor }"></div>
</div>
</div>
<div class="field">
<label>Name</label>
<div id="header_name" class="colorPicker">
  <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.header.name.textColor }"></div>
</div>
</div>
<div class="field">
<label>Status</label>
<div id="header_status" class="colorPicker">
  <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.header.status.textColor }"></div>
</div>
</div>
</div>

</div>

<div class="field">
<div class="fields">
<div class="field">
  <label>Middle</label>
  <div id="middle" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.middle.backgroundColor }"></div>
    </div>
</div>
<div class="field">
  <label>Answers</label>
  <div id="middle_bot_background" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.middle.bot.backgroundColor }"></div>
    </div>
</div>
<div class="field">
  <label>text</label>
  <div id="middle_bot_text" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.middle.bot.textColor }"></div>
    </div>
</div>
<div class="field">
  <label>Questions</label>
  <div id="middle_agent_background" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.middle.agent.backgroundColor }"></div>
    </div>
</div>
<div class="field">
  <label>text</label>
  <div id="middle_agent_text" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.middle.agent.textColor }"></div>
    </div>
</div>
</div>
</div>
<div class="field">
<div class="fields">
<div class="field">
  <label>Footer</label>
  <div id="footer" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.footer.backgroundColor }"></div>
    </div>
</div>
<div class="field">
  <label>Input</label>
  <div id="footer_input_background" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.footer.input.backgroundColor }"></div>
    </div>
</div>
<div class="field">
  <label>text</label>
  <div id="footer_input_text" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.footer.input.textColor }"></div>
    </div>
</div>
<div class="field">
  <label>Border</label>
  <div id="footer_input_border" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.footer.input.borderColor }"></div>
    </div>
</div>
<div class="field">
  <label>Button</label>
  <div id="footer_button_background" class="colorPicker">
      <div style="width: 100%; height: 40px;border-radius: 0.3rem; cursor:pointer;" :style="{'background': botConfig.style.footer.button.backgroundColor }"></div>
    </div>
</div>
</div>
</div>

<div class="field">
<label>Position</label>
<select class="ui dropdown" v-model="botConfig.position" >
<option :value="'left'">Left</option>
<option :value="'right'">Right</option>
</select>
</div>

</div>
</div>
</div>

<div style="text-align: right;" class="field">
<button @click="saveConfig()" class="ui fluid teal icon button">Save Changes</button>
</div>
</div>
</div>






<div class="ui padded segment">
<div class="ui top attached large label"><i class="question icon"></i> Frequently Asked Questions</div>
<div class="ui hidden divider"></div>
<div class="ui fluid accordion styled">
<div class="active title">
  <i class="dropdown icon"></i>
  What is Juphy and how does it work?
</div>
<div class="active content">
  <p>Juphy provides a cutting-edge AI Sales Assistant tailored for e-commerce operations. Think of it as adding a new member to your sales team, except that Juphy's smart AI Assistant is always on duty, learning about your business in no time and works 24/7.</p>
</div>
<div class="active title">
  <i class="dropdown icon"></i>
  Can you explain the process of one-click activation?
</div>
<div class="content">
  <div class="ui message">
<div class="header">
  One-click setup
</div>
<p>Simply click the green <b>Publish button</b> at top right corner of the screen to activate widget on your Shopify store.</p>
</div>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How to activate widget manually?
</div>
<div class="content">
  <div class="ui message">
<div class="header">
  Simple Manual Setup (only a few clicks required)
</div>
<p>Go to your store's Shopify admin panel and Just follow the straightforward instructions in our <b>10-seconds video guide</b> below.</p>
</div>
<!-- <img style="width: 100%;" src="https://juphy.com/wp-content/uploads/2023/12/how_to_activate-scaled.webp" alt=""> -->
<iframe width="100%" height="375" src="https://www.youtube.com/embed/nITf3hbKmQM?si=eJluWbbiMNHoa-xV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  Which e-commerce platforms does Juphy support?
</div>
<div class="content">
  <p>Juphy is exclusively designed for Shopify, one of the leading e-commerce platforms. We have optimized our solution to work seamlessly with Shopify’s interface and functionalities, ensuring a smooth and efficient experience for both store owners and customers. Juphy, Inc is an official partner of Shopify.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How does AI Shopping Asistant contribute to increasing sales?
</div>
<div class="content">
  <p>Juphy's AI Shopping Assistant contributes to increasing sales by engaging with customers 24/7, answering their questions, providing product recommendations, and facilitating the purchasing process.</p>
  <p>Our AI algorithms analyze customer behavior and preferences to offer personalized suggestions, significantly increasing the chances of conversion..</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How does Juphy integrate with Gorgias.com and other CRM tools?
</div>
<div class="content">
  <p>Juphy offers seamless integration with Gorgias.com and a variety of other CRM support tools to enhance your customer service experience. By connecting Juphy with Gorgias, you can synchronize customer interaction data, ensuring that your support team has access to all the necessary information right at their fingertips. This integration facilitates smoother transitions between AI-driven and human support, providing a comprehensive support system for your customers. Furthermore, we also support integrations with other popular CRM tools, allowing you to streamline your workflow and manage customer interactions more efficiently. Our dedicated integration support team is always available to assist you through the setup process and ensure that Juphy works harmoniously with your chosen CRM tools.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  Can chat widget be customized to match our brand’s voice and style?
</div>
<div class="content">
  <p>Absolutely! Juphy offers extensive customization options allowing you to tailor the chatbot’s responses, tone, and style to match your brand’s identity. This ensures a consistent and branded experience for your customers.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  What kind of reporting and analytics does Juphy provide?
</div>
<div class="content">
  <p>Juphy provides comprehensive reporting and analytics, giving you insights into customer interactions, sales conversions, and chatbot performance. This data can be utilized to optimize the chatbot’s responses and strategies, ensuring continuous improvement and better results over time.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How does Juphy handle complex customer queries?
</div>
<div class="content">
  <p>Juphy utilizes advanced natural language processing (NLP) to understand and respond to complex customer queries. In instances where the chatbot may not have a sufficient answer, it can be configured to escalate the query to a human representative, ensuring that your customers always receive the help they need.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How do you ensure data security and privacy for our customers’ information?
</div>
<div class="content">
  <p>At Juphy, we take data security and privacy very seriously. All customer interactions and data are encrypted and stored securely, ensuring the utmost protection of sensitive information. We are fully committed to complying with all relevant data protection regulations, including the General Data Protection Regulation (GDPR). Our GDPR-ready framework ensures that your customers’ information is safe, secure, and handled in accordance with the highest standards of data privacy. You can trust that with Juphy, your data is in good hands, and your privacy is our top priority.</p>
</div>
<div class="title">
  <i class="dropdown icon"></i>
  Can I add addtional AI Instruction into my AI Assistant?
</div>
<div class="content">
  <p>Yes! You can add additional short instructions below;</p>

  <div class="ui form">
<div class="field">
  <label>Instruction</label>
  <textarea v-model="botConfig.additionalInstruction"></textarea>
</div>
<div class="field">
  <div @click="saveConfig()" class="ui fluid button">Update</div>
</div>
</div>
  
</div>
<div class="title">
  <i class="dropdown icon"></i>
  How to remove widget from website?
</div>
<div class="content">
  <iframe width="100%" height="375" src="https://www.youtube.com/embed/nITf3hbKmQM?si=eJluWbbiMNHoa-xV" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>

<div class="ui message">
<p>To uninstall the widget from your store, follow the same procedure as shown in the above video. Simply click deactivate button and save changes. This action will completely remove the widget from your store.</p>
</div>
</div>
</div>


</div>
<div class="ui padded segment">
<div @click="updateAi()" :class="(loading.ai)? 'ui fluid button loading' : 'ui fluid button'">Force Update AI Assistant (API)</div>
<div class="ui divider"></div>
<div @click="updateAiByPublic()" :class="(loading.ai)? 'ui fluid button loading' : 'ui fluid button'">Force Update AI Assistant</div>
</div>

</div>

</div>
</div>
</span>



</template>

<style scoped>

.dot {
    opacity: 0.1; /* Start with dots hidden */
    animation: blink 1.7s infinite; /* Apply the blink animation */
}

/* Apply different animation delays to each dot to animate in order */
.dot:nth-child(1) { animation-delay: 0s; }
.dot:nth-child(2) { animation-delay: 0.33s; }
.dot:nth-child(3) { animation-delay: 0.66s; }

@keyframes blink {
    0%, 100% { opacity: 0; }
    50% { opacity: 1; }
}


.colorPicker {
  box-shadow: 1px 1px 5px #c5c5c5;
  border-radius: 5px;
}

pre {
  white-space: pre-wrap;       /* css-3 */
 white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
 white-space: -pre-wrap;      /* Opera 4-6 */
 white-space: -o-pre-wrap;    /* Opera 7 */
 word-wrap: break-word;       /* Internet Explorer 5.5+ */
}

::placeholder {
  color: #72777a;
  opacity: 0.7;
  font-size: 1rem;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #72777a;
  opacity: 0.7;
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #72777a;
  opacity: 0.7;
}

.guideContainer{
  background: rgba(0, 0, 0, 0.0);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}

.WebChatwidget {
  position: static;
  box-shadow: 2px 2px 20px rgba(0, 0, 0, 0.1);
  border-radius: 16px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
  border: 1px solid #CFCFCF;
  z-index: 9999999;
}
.wcw_wrapper {
  display: flex;
  max-height: 100%;
  border-radius: 16px;
  flex-direction: column;
  position: relative;
}

.wcw_wrapper .wcw_header {
  height: 100%;
  border-radius: 16px;
  background: #ffffff;
}

.wcw_wrapper .wcw_header .content {
  display: flex;
  position: relative;
  padding: 1rem;
  border-radius: 16px 16px 0 0;
}

/* .hidden {
  display: none !important;
} */

.wcw_wrapper .wcw_header .agents {
  margin-right: 12px;
  width: 2.75rem;
  height: 2.75rem;
}

.wcw_wrapper .wcw_header .status {
  display: flex;
  flex-direction: column;
}

.wcw_wrapper .wcw_header .status .label {
  display: flex;
  border-radius: 50px;
  align-items: center;
  height: 20px;
  align-items: center;
}
.wcw_wrapper .wcw_header .status .label div {
  width: 8px;
  height: 8px;
  margin-right: 4px;
  top: 10px;
}

.wcw_wrapper .wcw_header .status .label .widgetName {
  width: inherit;
  height: 1rem;
  font-family: Helvetica;
  font-size: 0.875rem;
  font-weight: bold;
  line-height: 1.25rem;
}

.wcw_wrapper .wcw_header .status .label .widgetStatus {
  width: inherit;
  height: 1rem;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 1rem;
}

.wcw_wrapper .wcw_header .status .label .indicator {
  height: 0.5rem;
  width: 0.5rem;
  background: #7DDE86;
  border-radius: 8px;
  display: block;
  margin-right: 5px;
}

.wcw_wrapper .wcw_header .content img {
  width: 40px;
  height: 40px;
  border-radius: 40px;
  border: 2px solid #fff;
  right: 0;
}

.wcw_wrapper .wcw_header .content .wcw_close {
  position: absolute;
  width: 44px;
  height: 44px;
  transition: 0.5s;
  border-radius: 8px;
  margin-right: 34px;
  right: 0;
  border: 1px solid;
  border-color: #e3e5e5;
  border-radius: 2rem;
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.wcw_wrapper .wcw_header .content .wcw_close .svg {
  display: inline-block;
  margin: 19%;
}

.wcw_wrapper .wcw_header .content:hover .wcw_close {
  opacity: 1;
}

.wcw_wrapper .wcw_header .content .wcw_close:hover {
  background: rgba(0, 0, 0, 0.05);
  cursor: pointer;
}

.wcw_wrapper .wcw_messages_container {
  overflow-y: scroll;
  overflow-x: hidden;
  height: 100vh;
  /* height: 500px; */
}

.wcw_wrapper form {
  justify-content: space-between;
  width: inherit;
  padding: 1rem;
  display: flex;
  margin: 0;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
}

.wcw_wrapper form > input {
  position: sticky;
  bottom: 0;
  height: 2.75rem;
  width: 100%;
  padding: 10px 20px 10px 20px;
  margin: auto;
  flex-grow: 1;
  max-height: 100%;
  border-radius: 1rem;
  font-size: 1rem;
  border: 1.5px solid;
  border-color: #dddddd;
  box-sizing: border-box;
}

.wcw_wrapper form > input:focus {
  outline: none;
}

.wcw_wrapper form > button {
  background: transparent;
  border-style: none;
  cursor: pointer;
  width: fit-content;
  margin-left: 1rem;
  padding: 0%;
}

#wcw_form_button #ic_send {
  fill: #444444;
  width: 2.75rem;
  height: 2.75rem;
}
#ic_send_icon path {
  fill: #ffffff;
  transform: scale(0.5633333333333334);
}
#wcw_form_button #ic_send #ic_send_icon {
  transform: translate(7px,5px);
}


.wcw_wrapper #wcw_messages {
  list-style-type: none;
  margin: 0;
  padding: 0 1rem 0 1rem;
  align-items: center;
}

.wcw_wrapper #wcw_messages > li {
  margin-bottom: 1rem;
  display: block;
}
.wcw_wrapper #wcw_messages > li.clearfix.bot {
  display: flex;
  width: fit-content;
  justify-content: flex-start;
}

.wcw_wrapper #wcw_messages > li:last-child {
  margin-bottom: 1rem;
  display: block;
}

.wcw_wrapper #wcw_messages > li:first-child {
  margin-top: 1rem;
}

.clearfix::after {
  content: "";
  clear: both;
  display: table;
}

.wcw_wrapper #wcw_messages > li > .content {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 24px;
  padding: 0.5rem 1rem;
  background: #f2f4f5;
  color: #303437;
  border-radius: 0px 24px 24px 24px;
  word-wrap: break-word;
  width: fit-content;
}

.wcw_wrapper #wcw_messages > li > img {
  width: 2rem;
  height: 2rem;
  align-self: flex-start;
  margin-right: 10px;
}

.wcw_wrapper #wcw_messages > li > .content.agent {
  padding: 0.5rem 1rem;
  color: #ffffff;
  background: #0070f0;
  border-radius: 24px 24px 0px 24px;
  float: right;
  max-width: 75%;
}
.wcw_wrapper #wcw_messages > li > .content.email {
  padding: 1rem;
  background: white;
  border-radius: 1rem;
  float: right;
  max-width: 70%;
}

.link-preview {
  display: flex;
  border: 1px solid rgba(0, 0, 0, 0.1);
  margin: 0.5rem 0;
  padding: 0.5rem;
  border-radius: 8px;
  background-color: #f5f5f5;
}

.preview-image {
  max-height: 100%;
  height: 80px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  border-radius: 8px;
  margin-bottom: 2px;
}

.preview-content {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding-left: 0.5rem;
}

.preview-title {
  font-weight: bold;
  margin-bottom: 0.25rem;
  font-size: medium;
  color: rgba(0, 0, 0, 0.7)
}

.preview-description {
  color: rgba(0, 0, 0, 0.7);
  font-size: small;
}

.form-container {
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: white;
  color: rgba(0, 0, 0, 0.7);
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  width: fit-content;
  float: right;
}

.form-container input[type="email"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px 0px 0px 5px;
  width: 100%;
  outline: none;
}
.form-container input[type="email"]::placeholder {
  opacity: 0.3;
}

.form-container button {
  padding: 5px 20px;
  background-color: #4169e1;
  border: none;
  border-radius: 0px 5px 5px 0px;
  color: white;
  cursor: pointer;
  font-size: 1.5rem;
  position: relative;
  overflow: hidden;
}

.form-container button::before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 1.5rem;
  line-height: 1;
}

.get-notified-text {
  font-size: 1.2rem;
  margin-bottom: 10px;
}

.input-group {
  display: flex;
}

.st0 {
  fill: none;
}

.buttonGroup {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.optionsButton {
  background-color: #e5eeff;
  color: #003499;
  padding: 10px 20px;
  border-radius: 6px;
  margin: 5px;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  font-size: 14px;
  line-height: 18px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 100%;
  white-space: nowrap;
}

.optionsButton:hover {
  color: #e5eeff;
  background-color: #003499;
  transition: all 0.5s;
}

.wcw_wrapper #wcw_messages > li > .content.richMsg {
  display: flex;
  flex-direction: column;
  border-radius: 0px 24px 24px 24px;
  line-height: 10px;
  background: #f2f4f5;
  padding: 1rem;
  position: relative;
}
/* .richMsgImg img {
  max-width: 100%;
  height: 8.125rem;
  border-radius: 10px;
  margin-top: 0.9rem;
  width: 100%;
} */

.richMsgImg {
  margin: 10px 0px;
}

.wcw_wrapper #wcw_messages>li>.content>.button{
  padding: 5px 7px; 
  background-color: var(--juphy-chatbot-background-color);
  color: #003499;
  border-radius: 0.5rem;
  margin: 5px;
  display: inline-block;
  font-size: 14px;
  cursor: pointer;
}

.wcw_wrapper #wcw_messages>li>.content>.button:hover{
    color: #e5eeff;
    background-color: #003499;
    transition: all 0.5s;
  }

.richMsgTitle {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 24px;
  color: #303437;
  font-weight: bold;
}
.richMsgDesc {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 1rem;
  line-height: 1.5rem;
  color: #303437;
  display: block;
}
.wcw_init {
  overflow: visible;
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  box-shadow: rgba(0, 18, 46, 0.16) 0px 8px 22px 0px;
  border-radius: 8px;
  background: #ffffff;
  color: rgba(0, 0, 0, 0.7);
}

.wcw_init .wcw_classic {
  padding: 8px 12px;
  cursor: pointer;
}


.richMsgButton > .button2 {
  border-radius: 24px;
  width: 100%;
  margin-right: 1rem;
  cursor: pointer;
  padding: 8px 0;
  /* border: 1px solid #C5D8FF; */
  border: none;
  background-color: rgba(210, 228, 254, 0.29);
  color: rgba(58, 86, 140, 0.9);
  font-size: 0.875rem;
  line-height: 1.5rem;
}

.richMsgButton > a {
  display: block;
  text-align: center;
}

/* Extra Small to Small screens */
@media screen and (max-width: 767px) {
  .WebChatwidget {
    height: 100%;
    width: 100%;
    top: 0;
    right: 0;
  }
}

/* Small to Medium screens */
@media screen and (min-width: 768px) and (max-width: 1000px) {
  .WebChatwidget {
    max-height: 100%;
    height: 80vh;
    width: 80vh;
    border-radius: 16px;
  }
}

/* Medium screens with a specific aspect ratio (e.g., 4:5) */
@media screen and (min-width: 768px) and (max-width: 1000px) and (max-aspect-ratio: 4/5) {
  .WebChatwidget {
    height: 60vh;
    width: 47vw;
  }
}

/* Large screens */
@media screen and (min-width: 1001px) and (min-height: 1000px) {
  .WebChatwidget {
    height: 60vh;
    width: 35vw;
  }
}

/* Extra Large screens */
@media screen and (min-width: 1001px) {
  .WebChatwidget {
    height: 70vh;
    width: 28vw;
  }
}

/* Large screens with specific height */
@media screen and (min-width: 900px) and (max-height: 900px) {
  .WebChatwidget {
    height: 85vh; 
    width: 27vw; 
  }
}

@media screen and (min-width: 1024px) and (min-height: 1366px) {
  .WebChatwidget {
    height: 60vh;
    width: 32vh;
  }
}

@media screen and (min-width: 1920px) and (min-height: 1080px) {
  .WebChatwidget {
    height: 60vh;
    width: 35vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/Widget.vue